import { MdcIpAddressType, IMdcSendOneResponse } from '../MDC/IMdc';
import { INmc } from './INmc';

export default class NotImplementedNmc implements INmc {
	public async sendOne(_ipAddress: MdcIpAddressType, _command: string[], _data: string[] | []): Promise<IMdcSendOneResponse> {
		return Promise.reject(new Error('Not implemented'));
	}
}
